<template>
  <div>
    <a-modal v-model="visibleQrModal" :footer="null" :destroy-on-close="true">
      <div class="flex justify-content-center">
        <qr-code-generator :link="baseUrl" />
      </div>
    </a-modal>
    <div class="flex justify-content-between align-items-center mb-3">
      <h3 class="m-0">Manual CDPH 530</h3>
      <div class="flex gap-2">
        <a-button :loading="attachmentState === 'loading'" @click="reloadAttachments" type="primary" icon="retweet"
          ghost></a-button>
        <a-button v-if="baseUrl && shift.shift.status !== 'deleted'" @click="openQrModal" type="primary" icon="plus"
          ghost>Add Manual CDPH 530 via Cell Phone</a-button>
      </div>
    </div>
    <shift-section-state :state="attachmentState" empty-title="No Manual CDPH 530 attachments"
      empty-description="Manual CDPH 530 files added to this shift will appear here."
      error-title="Attachments couldn't be loaded" error-description="Try loading the attachments again."
      show-content-when-empty test-id="shift-view-attachments-state" @retry="reloadAttachments">
      <shift-attachments :with-title="false" :files="files" :is-view="shift.shift.status === 'deleted'"
        :delete-confirmation="{
          title: 'Delete CDPH 530?',
          content:
            'Are you sure you want to delete the CDPH 530 attachment? This will permanently delete the attachment, and you won’t be able to restore it.'
        }" @save="saveAttachmentsIds" />
    </shift-section-state>
  </div>
</template>

<script>
import { Button, Modal, notification } from 'ant-design-vue'
import ShiftFormAttachments from '../../../../components/form-attachments.vue'
import { createNamespacedHelpers } from 'vuex'
import QrCodeGenerator from '@/components/qr-code-generator.vue'
import moment from 'moment-timezone'
import ShiftViewSectionState from '../shift-view-section-state.vue'

const { mapActions, mapGetters, mapState } = createNamespacedHelpers('shifts')

export default {
  components: {
    'a-button': Button,
    'a-modal': Modal,
    'shift-attachments': ShiftFormAttachments,
    'qr-code-generator': QrCodeGenerator,
    'shift-section-state': ShiftViewSectionState
  },
  data() {
    return {
      attachmentsIds: [],
      visibleQrModal: false,

      baseUrl: undefined,
      attachmentState: 'idle'
    }
  },
  computed: {
    ...mapGetters(['getActiveShiftId']),
    ...mapState({
      shift: state => state.shift,
      files: state => state.shift.shift.files
    })
  },
  watch: {
    files: {
      handler(newVal) {
        this.attachmentsIds = newVal.map(item => item.id)
        this.attachmentState = newVal.length ? 'ready' : 'empty'
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    ...mapActions(['updateShiftAttachments', 'getShiftAttachments']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    openQrModal() {
      this.visibleQrModal = true
    },

    closeQrModal() {
      this.visibleQrModal = false
    },

    async reloadAttachments() {
      this.attachmentState = 'loading'

      try {
        const payload = {
          id: this.shift.shift.id
        }

        await this.getShiftAttachments(payload)

        this.attachmentState = this.files.length ? 'ready' : 'empty'
      } catch (error) {
        this.attachmentState = 'error'
      }
    },

    async saveAttachmentsIds(ids) {
      this.attachmentsIds = ids
        .map(item => item.id)
        .filter(id => typeof id === 'number' || (typeof id === 'string' && /^\d+$/.test(id)))
        .map(id => Number(id))

      if (!this.getActiveShiftId) {
        this.showNotification('error', 'Error', 'Shift is not selected.')
        return
      }

      try {
        const payload = {
          files: this.attachmentsIds,
          shift_id: this.getActiveShiftId
        }

        await this.updateShiftAttachments(payload)

        this.showNotification('success', 'Success', 'Attachments were successfully changed')

        this.$emit('update', false)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error?.message)
      }
    }
  },

  mounted() {
    const path = window.location.origin

    if (this.shift?.associate?.id && this.shift?.shift?.id) {
      this.baseUrl = `${path}/whereami/#/attach-files?associate_id=${this.shift.associate.id
        }&shift_id=${this.shift.shift.id}&created_at=${moment().utc().seconds(0).format()}`
    }
  }
}
</script>
